var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sidebarElementGroup"},[_c('div',{staticClass:"sidebarElementGroup--name"},[_vm._v(_vm._s(_vm.group.groupName ?? "Untitled group"))]),_vm._l((_vm.group.groupElements),function(element,i){return _c('SidebarElement',{key:i,attrs:{"element":element}})}),_c('SidebarElementCreator',{attrs:{"groupID":_vm.group._id}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }